import Vue from 'vue';
import axios from 'axios';
import { getParamsFromDataAttributes } from '../util/url/searchParams';

import WizardRegistrazione from '../Components/landing-registrazione/WizardRegistrazione.vue';
import Landingboard from '../Components/landing-registrazione/Landingboard.vue';
import Loading from '../Components/Loading.vue';
import { RecoMixin } from '../common/RecoMixin';

axios.defaults.headers.common.Authorization = `Bearer ${window.token}`;
axios.defaults.baseURL = window.ResourceService;
axios.defaults.headers.post['Content-Type'] = 'application/json';
Vue.prototype.$http = axios;

const v = new Vue({
  el: '#app',

  components: {
    'wizard-registrazione': WizardRegistrazione,
    'landing-board': Landingboard,
    loading: Loading,

  },
  mixins: [RecoMixin],
  data: {
    requestId: '',
    params: {
      p: null,
      c: null,
      ass: null,
      event: null,
      article: null,
      paese: null,
      project: null,
      type: null,
      content: null,
      prodotto: null,
      codIso: null,
      lan: null,
    },
  },
  created() {},
  mounted() {
    this.params = getParamsFromDataAttributes('main');
  },
  methods: {
    showLoading(show) {
      this.$refs.loading.showLoading(show);
    },
  },
});
